export default __webpack_public_path__ + "9b9bc8d8103dcf2750ee954ed2f350cf.jpg";